import { useSelector } from 'react-redux'
import { selectActiveSection } from '../store/postSlice'

export default function usePostQueryKey() {
  const activeSection = useSelector(selectActiveSection)
  const filter = useSelector(state => state.post.filter)

  return ['posts', { section: activeSection?.slug, filter }]
}
